import * as React from "react"
const EmployeesmasterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M9.133 9.971c2.814-.173 4.951-2.525 4.773-5.255C13.728 1.987 11.303-.085 8.49.087 5.675.26 3.538 2.612 3.716 5.342c.178 2.73 2.603 4.802 5.417 4.629ZM10.607 15.169c0-1.712.726-3.257 1.896-4.371a8.445 8.445 0 0 0-1.131-.434c-.801.367-1.676.557-2.562.557-.92 0-1.786-.205-2.568-.56C2.785 11.42.28 14.554.28 18.258v3.517h17.078v-.492c-.141.01-.282.02-.423.02-3.491 0-6.328-2.751-6.328-6.134Z"
    />
    <path
      fill="#fff"
      d="M16.932 9.981c-2.956 0-5.348 2.324-5.348 5.188 0 2.867 2.395 5.187 5.348 5.187 2.956 0 5.348-2.323 5.348-5.187 0-2.864-2.396-5.188-5.348-5.188Zm3.115 4.768-1.442 1.014.55 1.64c.152.459-.387.838-.786.554l-1.44-1.015-1.442 1.015c-.401.284-.94-.099-.785-.553l.55-1.64-1.442-1.015c-.401-.284-.194-.9.3-.9h1.779l.55-1.64c.151-.457.82-.457.972 0l.55 1.64h1.779c.504.004.708.62.307.9Z"
    />
  </svg>
)
export default EmployeesmasterIcon
